module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Renee-meisje-doopsuiker-geboorte-5.d476124b.jpg";